import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Skeleton } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import { AuthContext } from "../../../context/auth-context";
import ProductItem from "../../CategoryDiscovery/Products/ProductItem";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import useCustomerReviews from "./../../CategoryDiscovery/CustomerReviews/useCustomerReviews";
import useClassifyProduct from "./../../CategoryDiscovery/Products/useClassifyProduct";
import CompetitorItem from "./CompetitorItem";
import classes from "./Competitors.module.css";
import { LLM_OPTIONS } from "../../../utils/constant";
import { filterKey } from "../BrandAudit";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";

export default function Competitors(
  { category, brand, llm, market, isCategoryOverview } = false
) {
  const [error, setError] = useState();
  const containerRef = useRef(null);
  const { user } = useContext(AuthContext);
  const { license_status } = user?.customer;
  const customer_id = user?.customer_id || 0;
  const language_id = user?.language_id || 1;

  const abortControllersRef = useRef([]);
  const discoveryCtx = useContext(DiscoveryContext);
  const { classifiedProducts } = useClassifyProduct();
  const { loading: reviewsLoading, reviews } = useCustomerReviews();

  let competitors = discoveryCtx.competitors[category].map((c) => c.name);

  let brandScoreTotal = discoveryCtx.brand_scores[llm][category]?.[1]?.total;
  useEffect(() => {
    if (brandScoreTotal > 0 || discoveryCtx.state.id) return;
    // getBrandIndexScores();

    return () => {
      //abortControllersRef.current.forEach((controller) => controller.abort());
    };
  }, [brandScoreTotal, competitors.length, discoveryCtx.state.id]);

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      abortControllersRef.current.forEach((controller) => controller.abort());
    }
  }, [discoveryCtx.abort_launch]);

  // function createPromise(product, index) {
  //   const controller = new AbortController();
  //   abortControllersRef.current[index] = controller;

  //   let sentimentCount = 5;
  //   const isWebSearch =
  //     llm === "gpt-4o-web-search" ||
  //     llm === "gpt-4o-agent-web-search";

  //   if (
  //     discoveryCtx.type === "category" ||
  //     llm === "deepseek_together"
  //   ) {
  //     sentimentCount = 1;
  //   } else if (isWebSearch) {
  //     sentimentCount = license_status === "Paid" ? 3 : 1;
  //   }

  //   const payload = {
  //     llm: llm,
  //     category: category,
  //     count: 5,
  //     brand: discoveryCtx.type === "brand" ? "companies" : "products",
  //     persona: "General Profile",
  //     return_meta: true,
  //     rank_exec_count:
  //       discoveryCtx.type === "category" ||
  //       llm === "deepseek_together"
  //         ? 1
  //         : 5,
  //     sentiment_exec_count: sentimentCount,
  //     market: market,
  //     product: product,
  //   };
  //   const configs = {
  //     signal: controller.signal,
  //   };
  //   return api.post(
  //     "/metrics/v4/get-brand-index-score?score_type_flag=sentiment",
  //     payload,
  //     configs
  //   );
  // }

  // async function getBrandIndexScores() {
  //   setError(null);
  //   abortControllersRef.current = [];

  //   try {
  //     const promiseArr = competitors.map((competitor, index) => {
  //       return createPromise(competitor, index);
  //     });

  //     promiseArr.forEach((promise, index) => {
  //       promise
  //         .then((result) => {
  //           const entity = result.data.data[0];
  //           discoveryCtx.updateBrandScores({res:{
  //             data: {
  //               name: entity.name,
  //               favorability: entity.score,
  //               extras: result.data.extras,
  //             },
  //             index: index + (discoveryCtx.type === "category" ? 0 : 1),
  //           },  req: {
  //             category, llm, market
  //           }});
  //         })
  //         .catch((error) => {
  //           discoveryCtx.updateBrandScores({res:{
  //             data: { error: error?.message },
  //             index: index + (discoveryCtx.type === "category" ? 0 : 1),
  //           }, req: {category, llm, market}});
  //         });
  //     });
  //   } catch (error) {
  //     setError(error.message);
  //   }
  // }

  // async function BrandIndexRetryHandler(index) {
  //   console.log(competitors[index]);
  //   discoveryCtx.updateBrandScores({res:{ data: null, index: index + 1 }, req: {llm, category, market}});
  //   const promiseArr = [];
  //   // promiseArr.push(createPromise(competitors[index]));

  //   try {
  //     const [response] = await Promise.all(promiseArr);
  //     const entity = response.data.data[0];
  //     discoveryCtx.updateBrandScores({res: {
  //       data: {
  //         name: entity.name,
  //         favorability: entity.score,
  //         extras: response.data.extras,
  //       },
  //       index: index + 1,
  //     }, req:{llm, category, market}} );
  //   } catch (error) {
  //     discoveryCtx.updateBrandScores({res:{
  //       data: { error: "someting went wrong" },
  //       index: index + 1,
  //     }, req:{llm, category, market}} );
  //   }
  // }

  let brandData = discoveryCtx.brand_scores[llm][category][market];
  console.log("brandData1", brandData, discoveryCtx.type, competitors);
  console.log("brandData2", llm, category, market);
  console.log("brandData3", brandData[0], brandData[1], brandData[2]);
  const scroll = (direction) => {
    if (containerRef.current) {
      const scrollAmount = 480;
      const newScrollPosition =
        direction === "next"
          ? containerRef.current.scrollLeft + scrollAmount
          : containerRef.current.scrollLeft - scrollAmount;
      containerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };

  let id = `${tab[category]}_competitor`;

  let uniqueKey = `${tab[category]}_${id}_${discoveryCtx.state.selectedLLM}`;

  const { checked } = useIsSelectedSection({ id, uniqueKey });

  return (
    // <MUICard
    //   title={
    //     discoveryCtx.type === "category" ? "Products" : "Competitor Analysis"
    //   }
    //   variant="elevated"
    //   elevation={0}
    //   className={classes.card}
    //   titleClassName={classes.title}
    //   width={"100%"}
    // >
    <MUICard>
      <div className="Heading-checkbox">
        <h5>
          {discoveryCtx.type === "category"
            ? "Products"
            : "Competitor Analysis"}
        </h5>

        {discoveryCtx.state.showReportCheckbox && isCategoryOverview && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: "Competitor Analysis",
                  tab: tab[category],
                  uniqueKey,
                   category: category,
                   market: market,
                   
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}

        <div
          style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}
          className={classes.dropdownWrapper}
          id="llm_options"
        >
          <MUISelect
            fullWidth={false}
            optionValue={discoveryCtx.state.selectedLLM}
            label={"LLM"}
            id={filterKey.llm}
            options={(discoveryCtx.llm || []).map((llm) => {
              const match = LLM_OPTIONS.find((option) => option.value === llm);
              return {
                name: match ? match.name : llm,
                value: llm,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedLLM(e.target.value);
            }}
          />
        </div>
      </div>

      {discoveryCtx.type === "category" && (
        <>
          <MUIIconButton
            className={`${classes.chevron_btn} ${classes.prev}`}
            onClick={() => scroll("prev")}
          >
            <ArrowBackIosNewIcon />
          </MUIIconButton>
          <MUIIconButton
            className={`${classes.chevron_btn} ${classes.next}`}
            onClick={() => scroll("next")}
          >
            <ArrowForwardIosIcon />
          </MUIIconButton>
        </>
      )}
      <div
        ref={containerRef}
        id={id}
        style={{ position: "relative" }}
        className={
          discoveryCtx.type === "category"
            ? classes.products_container
            : classes.container
        }
      >
        {!error &&
          competitors.map((competitor, index) => {
            return (
              <React.Fragment key={index}>
                {discoveryCtx.type === "category" ? (
                  <ProductItem
                    classifiedProducts={classifiedProducts}
                    index={index}
                    name={competitor}
                    brandIndex={
                      brandData[
                        index + (discoveryCtx.type === "category" ? 0 : 1)
                      ]
                    }
                    reviews={reviews[index]}
                    reviewLoading={reviewsLoading}
                  />
                ) : (
                  <React.Fragment key={index}>
                    {brandData[index + 1] ? (
                      <div id={`competitoritem-${index + 1}`}>
                        <CompetitorItem
                          competitor={competitor}
                          brandIndex={brandData[index + 1]}
                          brand={brand}
                          llm={llm}
                          category={category}
                          market={market}
                        />
                      </div>
                    ) : (
                      <Skeleton
                        variant="rounded"
                        style={{
                          flexGrow: 1,
                          height: 220,
                          flexBasis: "calc(50% - 12.5px)",
                        }}
                      />
                    )}
                    {index < competitors.length - 1 && (
                      <div className={classes.separator}></div>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            );
          })}
        {error && (
          <div className={classes.error}>
            <ErrorView
              title={"Error fetching competitor analysis"}
              message={error}
              retry
              // onRetry={() => getBrandIndexScores()}
            />
          </div>
        )}
      </div>
    </MUICard>
  );
}
